import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap } from 'rxjs';
import { PermissionService } from '../../shared/services/permesions/Permesions.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private router: Router, private http: HttpClient, private perms: PermissionService) {}

  isAuthenticated() {
    return !!localStorage.getItem('token');
  }

  retrieve(key: string): any {
    const item = localStorage.getItem(key);
    if (!item) return null;

    try {
      return JSON.parse(item);
    } catch {
      return item;
    }
  }

  store(key: string, value: any) {
    localStorage.setItem(key, typeof value === 'string' ? value : JSON.stringify(value));
  }

  remove(key: string) {
    localStorage.removeItem(key);
  }
  login(credentials: { email: string; password: string; RememberMe: boolean }): Observable<any> {
    return this.http.post('/auth/login', credentials);
  }
  OTP(OTPcredentials: { email: string; otp: string }): Observable<any> {
    return this.http.post('/auth/verify-otp', OTPcredentials);
  }

  logout(): Observable<any> {
    return this.http.post('/auth/logout', {}).pipe(
      tap({
        next: () => {
          this.remove('token');
          this.remove('permissions');
          this.perms.clear();
          this.router.navigate(['admin/login']);
        },
        error: (err) => {
          console.log(err);
        },
      })
    );
  }
  ForgetPassword(forgetcredentials: { email: string }): Observable<any> {
    return this.http.post('/auth/forgot-password/', forgetcredentials);
  }
  newPassword(
    token: string,
    Newpasscredentials: { password: string; password_confirmation: string }
  ) {
    return this.http.post(`/auth/change-password/${token}`, Newpasscredentials);
  }
  ResetPassword(Resetpasscredentials: {
    token: string;
    email: string;
    password: string;
    password_confirmation: string;
  }) {
    return this.http.post('/auth/reset-password/', Resetpasscredentials);
  }
  logOut(): void {
    const urlTree = this.router.parseUrl(this.router.url);
    const userRole = urlTree.root.children['primary']?.segments[0]?.path;
    this.remove('token');
    this.remove('permissions');
    this.perms.clear();
    this.router.navigate([`${userRole}/login`]);
  }
  // checkChangePassword(token: string): Observable<any> {
  //   return this.http.get(`/auth/change-password/${ token }`);
  // }
}
